import { render, staticRenderFns } from "./CourierDetails.vue?vue&type=template&id=75e7bff3&"
import script from "./CourierDetails.vue?vue&type=script&lang=js&"
export * from "./CourierDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports